export const additionalFeeWarning = (value, allValues) =>
	value === "true" ? "Additional Fee Warning" : undefined;
